import { render, staticRenderFns } from "./EditLongTail.vue?vue&type=template&id=cf115546&"
import script from "./EditLongTail.vue?vue&type=script&lang=js&"
export * from "./EditLongTail.vue?vue&type=script&lang=js&"
import style0 from "./EditLongTail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports